var CompareProduct = {};
CompareProduct.slider = function () {
  // Flickity Options
  var options = {
    cellAlign: 'center',
    prevNextButtons: true,
    pageDots: false,
    dragThreshold: 3,
    selectedAttraction: 0.05,
    freeScrollFriction: 0.02
  };
  if ($('body').hasClass('msie')) {
    options = {
      cellAlign: 'center',
      prevNextButtons: true,
      pageDots: false,
      dragThreshold: 3,
      draggable: false,
      selectedAttraction: 0.05,
      freeScrollFriction: 0.02
    };
  }

  // Compare Slider
  var $compareSlider = $('.js-compare-slider');
  var $firstProductHeight = $('.compare-product-body .product-first').height();
  function resizeFlickity() {
    setTimeout(function () {
      $compareSlider.flickity(options);
    }, 500);
    setTimeout(function () {
      var $secondProductHeight = $compareSlider.find('.flickity-viewport').height();
      if ($firstProductHeight < $secondProductHeight) {
        $('.compare-product-body').css('height', $secondProductHeight + 'px');
        $compareSlider.find('.flickity-viewport').css('min-height', 'initial');
      } else if ($firstProductHeight > $secondProductHeight) {
        $('.compare-product-body').css('height', 'initial');
        $compareSlider.find('.flickity-viewport').css('min-height', $firstProductHeight + 'px');
      }
      $compareSlider.css('visibility', 'visible');
    }, 1000);
  }
  $compareSlider.on('ready.flickity change.flickity', function () {
    resizeFlickity();
  });

  // Custom Page Dots
  var $sliderCompare = $compareSlider.flickity(options);
  var flktyCompare = $sliderCompare.data('flickity');
  var $comparePageDots = $('.page-dots');
  var $pageDots = $comparePageDots.find('.dot');
  $sliderCompare.on('select.flickity', function () {
    $pageDots.filter('.is-selected').removeClass('is-selected');
    $pageDots.eq(flktyCompare.selectedIndex).addClass('is-selected');
  });
  $comparePageDots.on('click', '.dot', function () {
    var thisDot = $(this);
    $sliderCompare.flickity('select', thisDot.index());
  });
};
CompareProduct.slider();
window.CompareProduct = CompareProduct;


// WEBPACK FOOTER //
// ./scripts/components/sliders/compare-product.js